<div class="dingo-ai-widget" [class.is-open]="isOpen">
  <div class="dingo-ai-panel" *ngIf="isOpen">
    <div class="dingo-ai-header">
      <div class="dingo-ai-identity">
        <div class="dingo-ai-avatar">
          <img src="assets/brand/logo.png" alt="Dingo AI" />
          <span class="dingo-ai-status"></span>
        </div>
        <div>
          <div class="dingo-ai-eyebrow">DINGO Assistant</div>
          <div class="dingo-ai-title">Diagnóstico rápido</div>
        </div>
      </div>
      <button type="button" class="dingo-ai-icon-btn" (click)="toggle()" aria-label="Minimizar chat">
        <i class="bi bi-dash-lg"></i>
      </button>
    </div>

    <div class="dingo-ai-intro">
      <span>Growth, pauta, automatización y tecnología.</span>
      <strong>Te orientamos en minutos.</strong>
    </div>

    <div class="dingo-ai-messages" #messagesContainer>
      <div *ngFor="let msg of messages; let i = index" [ngClass]="['dingo-ai-message', msg.role]">
        <div class="dingo-ai-message-meta" *ngIf="msg.role === 'assistant'">DINGO</div>
        <div class="bubble">
          <span>{{ getDisplayedContent(msg, i) }}</span><span class="typing-cursor" *ngIf="isTypingMessage(i)">|</span>
          <ng-container *ngIf="msg.role === 'assistant' && !isTypingMessage(i) && msg.suggestWhatsapp && msg.whatsappUrl">
            <div class="dingo-ai-message-cta">
              <button type="button" class="dingo-ai-action-primary" (click)="openWhatsapp(msg.whatsappUrl)">
                <i class="bi bi-whatsapp"></i>
                Hablar por WhatsApp
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="dingo-ai-message assistant" *ngIf="sending">
        <div class="dingo-ai-message-meta">DINGO</div>
        <div class="bubble dingo-ai-typing-bubble">
          <span class="dingo-ai-typing-dots">
            <span></span><span></span><span></span>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="error" class="dingo-ai-error">
      {{ error }}
    </div>

    <div class="dingo-ai-quick-actions" *ngIf="showQuickActions()">
      <button
        type="button"
        class="dingo-ai-quick-btn"
        *ngFor="let action of quickActions"
        (click)="handleQuickAction(action)"
      >
        <i class="bi" [ngClass]="action.type === 'whatsapp' ? 'bi-whatsapp' : 'bi-arrow-up-right'"></i>
        {{ action.label }}
      </button>
    </div>

    <div class="dingo-ai-closing-ctas" *ngIf="shouldShowClosingCtas()">
      <button type="button" class="dingo-ai-action-primary" (click)="openWhatsapp()">
        <i class="bi bi-whatsapp"></i>
        Hablar por WhatsApp
      </button>
    </div>

    <form (ngSubmit)="send()" class="dingo-ai-input">
      <textarea
        rows="2"
        [(ngModel)]="input"
        name="dingoInput"
        (keydown)="onInputKeydown($event)"
        [disabled]="sending"
        placeholder="Escribe tu pregunta..."
      ></textarea>
      <button type="submit" class="dingo-ai-send-btn" [disabled]="sending || !input.trim()" aria-label="Enviar mensaje">
        <i class="bi bi-send"></i>
      </button>
    </form>

    <div class="dingo-ai-footer">
      <span></span>
      Desarrollado por <strong>Grupo DINGO</strong>
    </div>
  </div>

  <button
    type="button"
    class="dingo-ai-bubble"
    (click)="toggle()"
    aria-label="Abrir chat Dingo AI"
  >
    <span class="dingo-ai-bubble-pulse"></span>
    <i class="bi" [ngClass]="isOpen ? 'bi-x-lg' : 'bi-chat-dots'"></i>
  </button>
</div>
